import styled from "@emotion/styled"

export const FeaturesTileContainer = styled.div`
  .tile.is-vertical > .tile.is-child:not(:last-child) {
    margin-bottom: 0.5rem !important;
  }
`
